import { useEffect, useState } from 'react';
import { useRealtime } from '../realtime/RealtimeProvider';

/**
 * UJ VERZIO ERHETO EL - sav a lap tetejen.
 *
 * A nyitva hagyott ful a deploy utan is a REGI programot futtatja, amig nem
 * frissitik. Ez nem csak kinezet: a kollegak egymashoz kepest mast lattak
 * (egy telefonhivas naplosora az egyiknel az uj, a masiknal a regi formaban
 * allt), es a regi felulet a szerver uj szabalyait sem ismerte.
 *
 * Hogyan derul ki: az `index.html` gyorsitotarazas nelkul jon, es a benne
 * hivatkozott fo szkript neve a build lenyomatat viseli. Ha az most mas, mint
 * amit ez a lap betoltott, uj verzio van kint. Ellenorizzuk ujracsatlakozaskor
 * (a deploy ujrainditja a szervert), a fulre visszaterve, es tizpercenkent.
 *
 * NEM toltunk ujra magunktol: az megszakitana egy felig megirt uzenetet. A
 * hivas a kulon ablakban fut, azt ez a sav nem erinti.
 */
const CHECK_INTERVAL_MS = 10 * 60 * 1000;

function currentScript(): string | null {
  const script = document.querySelector<HTMLScriptElement>('script[type="module"][src]');
  return script ? new URL(script.src, window.location.href).pathname : null;
}

async function publishedScript(): Promise<string | null> {
  try {
    const response = await fetch('/', { cache: 'no-store' });
    if (!response.ok) return null;
    const html = await response.text();
    const match = /<script[^>]+type="module"[^>]+src="([^"]+)"/.exec(html);
    return match ? new URL(match[1]!, window.location.href).pathname : null;
  } catch {
    return null;
  }
}

export function UpdateNotice() {
  const { status } = useRealtime();
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const loaded = currentScript();
    // Fejlesztoi szerveren (vite) nincs lenyomatos fo szkript - ott nem figyelunk.
    if (!loaded || !/\/assets\//.test(loaded)) return;

    let stopped = false;
    const check = async () => {
      const published = await publishedScript();
      if (!stopped && published && published !== loaded) setOutdated(true);
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') void check();
    };
    document.addEventListener('visibilitychange', onVisible);
    const timer = setInterval(() => void check(), CHECK_INTERVAL_MS);
    if (status === 'online') void check();

    return () => {
      stopped = true;
      document.removeEventListener('visibilitychange', onVisible);
      clearInterval(timer);
    };
  }, [status]);

  if (!outdated) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 border-b border-border-soft bg-accent-soft px-4 py-1.5 text-sm text-ink"
    >
      <span>Megjelent az AVSlack új verziója.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-control bg-accent px-2.5 py-0.5 text-xs font-semibold text-accent-ink hover:bg-accent-hover"
      >
        Frissítés
      </button>
    </div>
  );
}
